const icsRoutes = [
	{
		path: '/ics',
		name: 'ics-default',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'ICS Tasks',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app', 'test.apps.ics.app', 'use.apps.ics.app'],
		},
	},

	{
		path: '/ics/tasks',
		name: 'ics-tasks',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'ICS Tasks',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app', 'test.apps.ics.app', 'use.apps.ics.app'],
		},
	},

	{
		path: '/ics/tasks/:uuid',
		name: 'ics-tasks-resource',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tasks' },
		meta: {
			name: 'ICS Tasks',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app', 'test.apps.ics.app', 'use.apps.ics.app'],
		},
	},

	{
		path: '/ics/processes',
		name: 'ics-processes',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'processes', scene: 'processes' },
		meta: {
			name: 'Processes',
			permissions: ['*'],
		},
	},

	{
		path: '/ics/processes/entities',
		name: 'ics-processes-entities',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'processes', scene: 'entities' },
		meta: {
			permissions: ['*'],
		},
	},

	{
		path: '/ics/explorer',
		name: 'ics-explorer',
		redirect: { name: 'ics-explorer-tree' },
		meta: {
			permissions: ['*'],
		},
	},

	{
		path: '/ics/explorer/tree',
		name: 'ics-explorer-tree',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'explorer', scene: 'tree' },
		meta: {
			name: 'ICS Explorer Tree',
			permissions: ['*'],
		},
	},

	{
		path: '/ics/controls',
		name: 'ics-controls',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'controls' },
		meta: {
			name: 'ICS Controls',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app', 'use.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator',
		name: 'ics-coordinator',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'dashboard' },
		meta: {
			name: 'ICS Dashboard',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/rcm',
		name: 'ics-coordinator-rcm',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'rcm' },
		meta: {
			name: 'ICS RCM',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/rcm/:uuid',
		name: 'ics-coordinator-rcm-resource',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'rcm' },
		meta: {
			name: 'ICS RCM',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
			quicklink: 'ics-coordinator-rcm',
		},
	},

	{
		path: '/ics/coordinator/runs',
		name: 'ics-coordinator-runs',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'control_runs' },
		meta: {
			name: 'ICS Control Runs',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/tickets',
		name: 'ics-coordinator-tickets',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'tickets' },
		meta: {
			name: 'ICS Measures',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/deficiencies/assessments',
		name: 'ics-coordinator-deficiencies-assessments',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'assessments' },
		meta: {
			name: 'ICS Assessments',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/deficiencies/deficiencies',
		name: 'ics-coordinator-deficiencies-deficiencies',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'deficiencies' },
		meta: {
			name: 'ICS Deficiencies',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/deficiencies/gaps',
		name: 'ics-coordinator-deficiencies-gaps',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'gaps' },
		meta: {
			name: 'ICS Gaps',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/remediations',
		name: 'ics-coordinator-remediations',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/remediations/:uuid',
		name: 'ics-coordinator-remediations-resource',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
			quicklink: 'ics-coordinator-remediations',
		},
	},

	{
		path: '/ics/coordinator/deficiencies',
		name: 'ics-coordinator-deficiencies',
		redirect: { name: 'ics-coordinator-deficiencies-deficiencies' },
		meta: {
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/ipe-testing',
		name: 'ics-coordinator-ipe-testing',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'ipe_testing' },
		meta: {
			name: 'ICS IPE Testing',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/users',
		name: 'ics-coordinator-users',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'users' },
		meta: {
			name: 'ICS Users',
			permissions: ['admin.apps.ics.app', 'manage.apps.ics.app'],
		},
	},

	{
		path: '/ics/coordinator/activity-log',
		name: 'ics-coordinator-activity-log',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'coordinator', scene: 'activity_log' },
		meta: {
			name: 'ICS Activity Log',
			permissions: ['admin.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester',
		name: 'ics-tester',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'dashboard' },
		meta: {
			name: 'ICS Dashboard',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/rcm',
		name: 'ics-tester-rcm',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'rcm' },
		meta: {
			name: 'ICS RCM',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/runs',
		name: 'ics-tester-runs',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'test_runs' },
		meta: {
			name: 'ICS Test Runs',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/walkthroughs',
		name: 'ics-tester-walkthroughs',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'walkthroughs' },
		meta: {
			name: 'ICS Walkthroughs',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/schedules',
		name: 'ics-tester-schedules',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'testing_schedules' },
		meta: {
			name: 'ICS Schedules',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/tickets',
		name: 'ics-tester-tickets',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'tickets' },
		meta: {
			name: 'ICS Tickets',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/deficiencies/assessments',
		name: 'ics-tester-deficiencies-assessments',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'control_assessments' },
		meta: {
			name: 'ICS Assessments',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/deficiencies/deficiencies',
		name: 'ics-tester-deficiencies-deficiencies',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'deficiencies' },
		meta: {
			name: 'ICS Deficiencies',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/deficiencies/gaps',
		name: 'ics-tester-deficiencies-gaps',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'gaps' },
		meta: {
			name: 'ICS Gaps',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/tester/remediations',
		name: 'ics-tester-remediations',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
			quicklink: 'ics-tester-remediations',
		},
	},

	{
		path: '/ics/tester/remediations/:uuid',
		name: 'ics-tester-remediations-resource',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'tester', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
			quicklink: 'ics-tester-remediations',
		},
	},

	{
		path: '/ics/tester/deficiencies',
		name: 'ics-tester-deficiencies',
		redirect: { name: 'ics-tester-deficiencies-deficiencies' },
		meta: {
			permissions: ['admin.apps.ics.app', 'test.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor',
		name: 'ics-auditor',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'rcm' },
		meta: {
			name: 'ICS Dashboard',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/rcm',
		name: 'ics-auditor-rcm',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'rcm' },
		meta: {
			name: 'ICS RCM',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/runs',
		name: 'ics-auditor-runs',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'control_runs' },
		meta: {
			name: 'ICS Control Runs',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/deficiencies/assessments',
		name: 'ics-auditor-deficiencies-assessments',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'control_assessments' },
		meta: {
			name: 'ICS Assessments',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/deficiencies/deficiencies',
		name: 'ics-auditor-deficiencies-deficiencies',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'deficiencies' },
		meta: {
			name: 'ICS Deficiencies',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/deficiencies/gaps',
		name: 'ics-auditor-deficiencies-gaps',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'gaps' },
		meta: {
			name: 'ICS Gaps',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},

	{
		path: '/ics/auditor/remediations',
		name: 'ics-auditor-remediations',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
			quicklink: 'ics-auditor-remediations',
		},
	},

	{
		path: '/ics/auditor/remediations/:uuid',
		name: 'ics-auditor-remediations-resource',
		component: () => import('@/apps/ics/Home.vue'),
		props: { view: 'auditor', scene: 'remediations' },
		meta: {
			name: 'ICS Remediations',
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
			quicklink: 'ics-auditor-remediations',
		},
	},

	{
		path: '/ics/auditor/deficiencies',
		name: 'ics-auditor-deficiencies',
		redirect: { name: 'ics-auditor-deficiencies-deficiencies' },
		meta: {
			permissions: ['admin.apps.ics.app', 'audit.apps.ics.app'],
		},
	},
]

export default icsRoutes
